import { useContext } from "react";
import AppConxt from "../AppContext";
import axios from "axios";

function useMeteringPoints() {
  const context = useContext(AppConxt);

  async function getPoints(limit = 9999999999) {
    return context.keycloak
      .updateToken(5)
      .then(function () {
        const headers = { Authorization: "Bearer " + context.keycloak.token };
        return axios
          .get(context.config.meteringPointsAPI + "/", {
            headers,
            params: { limit },
          })
          .then((response) => {
            return response.data;
          });
      })
      .catch(function () {
        context.keycloak.login();
      });
  }

  async function getQuarantined(limit = 9999999999) {
    return context.keycloak
      .updateToken(5)
      .then(function () {
        const headers = { Authorization: "Bearer " + context.keycloak.token };
        return axios
          .get(context.config.meteringPointsAPI + "/reference_periods/reference_period_quarantined", {
            headers,
            params: { limit },
          })
          .then((response) => {
            return response.data;
          });
      })
      .catch(function () {
        context.keycloak.login();
      });
  } 

  async function getRefPeriodChanged(limit = 10000) {
    return context.keycloak
      .updateToken(5)
      .then(function () {
        const headers = { Authorization: "Bearer " + context.keycloak.token };
        return axios
          .get(context.config.meteringPointsAPI + "/reference_periods/reference_period_changed", {
            headers,
            params: { limit },
          })
          .then((response) => {
            return response.data;
          });
      })
      .catch(function () {
        context.keycloak.login();
      });
  }

  return { getPoints, getQuarantined, getRefPeriodChanged };
}

export default useMeteringPoints;
